// node_modules
import { FC, useEffect } from "react";
// Components
import { AsynchronousWrapper } from "Components";
import { Image } from "Components/Case/Results/TechnologyMedia/Image";
// Custom hooks
import { useFetch } from "Hooks";
// Types
import { TTechnologyImageDTO, TUseFetch } from "Types";
// Styles
import styles from "./technologyReferenceModalContent.module.scss";
import { PendoHelperSingleton } from "Helpers";
import { LoggingConstants } from "Constants";

type TTechnologyImageModalContentProps = {
    technologyId: string,
    imageId: string
}

export const TechnologyImageModalContent: FC<TTechnologyImageModalContentProps> = ({technologyId, imageId}: TTechnologyImageModalContentProps) => {
    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TTechnologyImageDTO> 
        = useFetch(`api/technologies/${technologyId}/medias/savedimages/${imageId}`);

    useEffect(() => {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}GetSavedImage`, {
            technologyId: technologyId,
            imageId: imageId
        });
    }, [technologyId, imageId]);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            {fetchedData ?
                    <div className={styles.technologyImageModelContainer}>
                        <Image 
                            caption={fetchedData.caption} 
                            link={fetchedData.link}/>
                    </div>
                :
                    <></>

            }
        </AsynchronousWrapper>
    );
};